const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M4 11.25a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  e as w
};
